<template>
  <el-drawer title="工单详情" :visible.sync="drawer" :direction="direction">
    <div class="detail-content">
      <p class="title">基本信息</p>
      <el-form :model="detail" :size="size" ref="dataForm" label-position='right' label-width="120px">
        <el-form-item label="计划名称">
          <span>{{ detail.name }}</span>
        </el-form-item>
        <el-form-item label="客户">
          <span>{{ detail.clientCompanyName }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>{{ detail.type }}</span>
        </el-form-item>
        <el-form-item label="状态">
          <span>{{ handleStatusFormat(  detail.state) }}</span>
        </el-form-item>
        <el-form-item label="创建人">
          <span>{{ detail.planCreatorUserName }}</span>
        </el-form-item>
        <el-form-item label="计划起止时间">
          <span>{{$moment(detail.startTime).format('YYYY/MM/DD')}} - {{$moment(detail.endTime).format('YYYY/MM/DD')}}</span>
        </el-form-item>
        <el-form-item label="描述">
          <span>{{ detail.describe }}</span>
        </el-form-item>
      </el-form>
      <p class="title">关联项目信息</p>
      <el-form :size="size" label-position='right' label-width="160px">
        <el-form-item label="项目名称">
          <span>{{ detail.contractProjectName }}</span>
        </el-form-item>
        <el-form-item label="项目编号">
          <span>{{ detail.contractProjectNumber }}</span>
        </el-form-item>
        <el-form-item label="服务区域">
          <span>{{ detail.workingArea }}</span>
        </el-form-item>
        <el-form-item label="关联设备">
          <div class="tree-content">
            <el-tree :data="detail.measureList" show-checkbox default-expand-all node-key="measureId" ref="tree" highlight-current :props="defaultProps">
            </el-tree>
          </div>
        </el-form-item>
        <el-form-item label="联系人">
          <span>{{ detail.clientContactPerson }}</span>
        </el-form-item>
        <el-form-item label="联系号码">
          <span>{{ detail.clientContactPhoneNumber }}</span>
        </el-form-item>
        <el-form-item label="经纬度">
          <span>{{ detail.clientAddressLongitude }},{{ detail.clientAddressLatitude }}</span>
        </el-form-item>
        <el-form-item label="地址信息">
          <span>{{ detail.clientAddress }}</span>
        </el-form-item>
        <el-form-item label="详细地址">
          <span>{{ detail.clientAddressDetail }}</span>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import tree from '@/utils/tree'
export default {
  name: 'detail',
  props: {
    statusList: Array,
    typeList: Array,
    cycleList: Array
  },
  data () {
    return {
      size: 'small',
      drawer: false,
      direction: 'rtl',
      treeData: [],
      detail: {},
      project: {},
      defaultProps: {
        label: 'measureName',
        children: 'children',
        disabled: this.disabledFn
      }
    }
  },
  methods: {
    disabledFn () {
      return true
    },
    async init (row) {
      this.drawer = true
      this.detail = Object.assign({}, row)
      this.detail.type = this.handleTypeFormat(this.detail.type)
      this.detail.status = this.handleStatusFormat(this.detail.status)
    },
    handleTypeFormat (cellValue) {
      let val = ''
      this.typeList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleStatusFormat (cellValue) {
      let val = ''
      this.statusList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
  }
}
</script>

<style lang="scss" scoped>
.detail-content {
  color: #333;
  padding: 16px;
  text-align: left;
  .title {
    font-size: 18px;
  }
}

.el-form-item {
  margin-bottom: 6px;
}

.tree-content {
  ::v-deep .el-checkbox.is-disabled.is-checked {
    color: #409eff;
    .el-checkbox__inner {
      background-color: #409eff;
      border-color: #409eff;
      &::after {
        border-color: #fff;
      }
    }
  }
}
</style>
